import script from "./TranslationsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslationsDialog.vue?vue&type=script&setup=true&lang=js"

import "./TranslationsDialog.vue?vue&type=style&index=0&id=21bfaa67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21bfaa67"]])

export default __exports__